import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommCheckSingleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M18.658 6.64016C18.8568 7.00358 18.7233 7.4593 18.3599 7.65805C16.1314 8.87676 14.1154 11.3668 12.628 13.6445C11.8934 14.7692 11.305 15.815 10.9004 16.5794C10.6983 16.9612 10.5425 17.2719 10.4378 17.486C10.3855 17.593 10.346 17.6758 10.3198 17.7312L10.2907 17.7933L10.2838 17.8082L10.2823 17.8114C10.1664 18.0647 9.91947 18.2335 9.64134 18.2489C9.36315 18.2642 9.09938 18.1241 8.95636 17.885C8.42333 16.9939 7.60302 16.2163 6.88486 15.6485C6.53061 15.3684 6.21177 15.1476 5.98279 14.9976C5.8685 14.9228 5.77717 14.8659 5.7157 14.8285C5.68498 14.8098 5.66176 14.796 5.64692 14.7873L5.63106 14.778L5.62845 14.7765C5.26882 14.5712 5.14335 14.1132 5.34852 13.7535C5.55373 13.3936 6.01176 13.2683 6.37157 13.4735L6.00001 14.125C6.37157 13.4735 6.37157 13.4735 6.37157 13.4735L6.37307 13.4744L6.37545 13.4757L6.3828 13.48L6.40759 13.4945C6.42849 13.5068 6.45801 13.5243 6.49526 13.547C6.56972 13.5923 6.67526 13.6581 6.80473 13.7429C7.06324 13.9122 7.4194 14.159 7.81516 14.4719C8.33272 14.8811 8.93699 15.4181 9.47984 16.0579C9.51028 15.9997 9.54189 15.9395 9.57464 15.8777C9.99502 15.0835 10.6066 13.9964 11.3721 12.8243C12.8846 10.5083 15.0687 7.74827 17.6401 6.34199C18.0036 6.14325 18.4593 6.27674 18.658 6.64016Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
